import React from 'react';
import { useTranslation } from 'react-i18next';
import './Hero.css';

/**
 * Top of the groups page: the headline and the problem, centred. What Revetall is follows
 * in the assistant section below.
 * @returns {JSX.Element} Hero section
 */
function Hero() {
  const { t } = useTranslation();

  return (
    <section className="hero">
      <div className="hero-content">
        <h1 className="hero-title">{t('hero.title')}</h1>
        <p className="hero-problem">{t('hero.problem')}</p>
      </div>
    </section>
  );
}

export default Hero;
